export enum LanguageLocale {
    EN = "en",
    PL = "pl"
}

export enum LanguageLocaleType {
    en = "en-GB",
    pl = "pl-PL"
}
